import React from 'react';
import type { Case } from '@lnr-v2/types';
import { CaseTag } from '../../atoms';
import styles from './CaseCard.module.css';

interface CaseCardProps {
  case: Case;
  isActive?: boolean;
  className?: string;
}

export const CaseCard: React.FC<CaseCardProps> = ({
  case: caseData,
  isActive = false,
  className,
}) => {
  const imageUrl = caseData.cover || caseData.thumbnailImage;
  const clientName = caseData.clientName || caseData.name;
  const slogan = caseData.slogan || caseData.quickDescription;

  return (
    <article
      className={`${styles.caseCard} ${isActive ? styles.active : ''} ${className || ''}`}
    >
      {imageUrl && (
        <div className={styles.imageContainer}>
          <img
            src={imageUrl}
            alt={clientName}
            className={styles.caseImage}
            width="335"
            height="490"
          />

          <div className={styles.contentOverlay}>
            <div className={styles.textContent}>
              <h3 className={styles.clientName}>{clientName}</h3>
              {slogan && <p className={styles.slogan}>{slogan}</p>}
            </div>

            {caseData.tags && caseData.tags.length > 0 && (
              <div className={styles.tagsContainer}>
                {caseData.tags.map((tag, index) => (
                  <CaseTag
                    key={index}
                    label={tag}
                    variant={index === 0 ? 'filled' : 'outlined'}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </article>
  );
};
